module.exports = __webpack_public_path__ + "static/img/cont56 (3).593e3c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont56 (3).jpg
// module id = 5rr6
// module chunks = 0